<template>
  <div class="chart" style="height: 230px; width: 100%"></div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import { debounce } from "lodash";
export default {
  props: {
    isLScreenStyle: {
      type: Object,
      require: false,
      default: () => {},
    },
    options: {
      type: Object,
      require: true,
      default: () => {},
    },
    title: {
      type: String,
      require: false
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHanlder = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    });
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      const { islscreen } = this.$route.query;
      const { gridlinesColor, xAxisColor, yAxisColor } = this.isLScreenStyle;
      this.chart = echarts.init(this.$el, "macarons");
      let XData = ["12", "13", "14", "15", "16", "17", "18"];
      let valueData = [117, 47, 68, 118, 138, 38, 58];
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            show: true,
            status: "shadow",
            z: -1,
            shadowStyle: {
              color: "rgba(81, 138, 252, 0.1)",
            },
            type: "shadow",
          },
        },
        grid: {
          top: "5%",
          left: "2%",
          right: "2%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: [
          {
            position: "bottom",
            type: "category",
            axisLine: {
              show: true,
              lineStyle: {
                color: islscreen ? gridlinesColor : "#EFEFEF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              rotate: 0,
              fontSize: 12,
              color: islscreen ? xAxisColor : "rgba(0, 0, 0, 1)",
            },
            splitLine: {
              show: islscreen ? true : false,
              lineStyle: {
                color: [islscreen ? gridlinesColor : ""],
              },
            },
            gridIndex: 0,
            data: this.options.XData,
          },
        ],
        yAxis: [
          {
            type: "value",
            position: "left",
            minInterval: 1,
            axisLine: {
              show: true,
              lineStyle: {
                color: islscreen ? gridlinesColor : "#EFEFEF",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              rotate: 0,
              fontSize: 12,
              // color: 'rgba(0, 0, 0, 1)',
              color: islscreen ? yAxisColor : "rgba(0, 0, 0, 1)",
            },
            splitLine: {
              show: islscreen ? true : false,
              lineStyle: {
                color: [islscreen ? gridlinesColor : ""],
              },
            },
            splitArea: { show: false },
          },
        ],
        series: [
          {
            name: this.title ? this.title : '',
            type: "bar",
            data: this.options.valueData,
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0],
                color: this.options.columnColor,
              },
            },
            label: {
              normal: {
                show: false,
              },
            },
          },
        ],
      });
    },
  },
  created: function () {},
  computed: {},
  watch: {
    options: {
      deep: true,
      handler() {
        this.initChart();
      },
    },
  },
};
</script>
